module.exports = __webpack_public_path__ + "img/off_inspector_llenas.7d396cac.png";